module.exports = __webpack_public_path__ + "img/m_img8.f7b85495.png";